<ion-header *ngIf="isModal">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title>{{ 'option.' + option | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="applySelected()" color="primary">
        <ion-icon name="checkmark-outline" slot="start"></ion-icon>
        Aplicar Selección
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [scrollY]="true">
  <ion-grid fixed>
    <ion-row>
      <ion-col *ngFor="let item of melateTickets; let i = index" size="12">
        <ion-card class="ion-no-margin melate">
          <ion-card-content class="ion-no-padding">
            <ion-grid>
              <ion-row class="ion-no-padding selecteds">
                <ion-fab-button *ngFor="let val of item.value" size="small">
                  {{ val }}
                </ion-fab-button>
              </ion-row>
              <ion-toolbar class="toolbar">
                <ion-img slot="start" class="ion-margin-top small" [src]="melateLogo"></ion-img>

                <ion-buttons slot="end">
                  <ion-button (click)="changeSelected(i)" [color]="selected[i] ? 'success' : 'light'">
                    <ion-icon
                      slot="icon-only"
                      [name]="selected[i] ? 'checkmark-circle-outline' : 'ellipse-outline'"
                    ></ion-icon>
                  </ion-button>
                  <!-- <ion-button *ngIf="option === 'automatic'" (click)="reload(i)" color="secondary">
                    <ion-icon slot="icon-only" name="refresh"></ion-icon>
                  </ion-button>
                  <ion-button *ngIf="option !== 'coperacha'" (click)="goTo()" color="secondary">
                    <ion-icon slot="icon-only" name="create-outline"></ion-icon>
                  </ion-button> -->
                  <ion-button (click)="deleteValue(i)" color="danger">
                    <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                  </ion-button>
                </ion-buttons>
              </ion-toolbar>
            </ion-grid>
          </ion-card-content>
        </ion-card>
      </ion-col>

      <ion-col *ngFor="let item of sorteoTickets; let i = index" size="12">
        <ion-card class="ion-no-margin sorteo">
          <ion-card-content class="ion-no-padding">
            <ion-grid>
              <ion-row class="ion-no-padding selecteds">
                <ion-fab-button *ngFor="let val of item.value" size="small" [class]="sorteoType">
                  {{ val }}
                </ion-fab-button>
              </ion-row>

              <ion-toolbar class="toolbar">
                <ion-img
                  slot="start"
                  class="ion-margin-top small"
                  [src]="'/assets/logos/sorteo-' + sorteoType + '.svg'"
                ></ion-img>
                <ion-row *ngIf="item.icon">
                  <img [src]="getZodiacIcon(item.icon)" />
                  <p class="center">{{ getZodiacName(item.icon) }}</p>
                </ion-row>

                <ion-buttons slot="end">
                  <ion-button (click)="changeSelected(i)" [color]="selected[i] ? 'success' : 'light'">
                    <ion-icon
                      slot="icon-only"
                      [name]="selected[i] ? 'checkmark-circle-outline' : 'ellipse-outline'"
                    ></ion-icon>
                  </ion-button>

                  <!-- <ion-button *ngIf="option === 'automatic'" (click)="reload(i)" color="secondary">
                    <ion-icon slot="icon-only" name="refresh"></ion-icon>
                  </ion-button>

                  <ion-button *ngIf="option !== 'coperacha'" (click)="goTo()" color="secondary">
                    <ion-icon slot="icon-only" name="create-outline"></ion-icon>
                  </ion-button> -->

                  <ion-button (click)="deleteValue(i)" color="danger">
                    <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                  </ion-button>
                </ion-buttons>
              </ion-toolbar>
            </ion-grid>
          </ion-card-content>
        </ion-card>
      </ion-col>
      <ion-col *ngFor="let item of chispazoTickets; let i = index" size="12">
        <ion-card class="ion-no-margin chispazo" [ngClass]="{ 'selected-card': selected[i] }">
          <ion-card-content class="ion-no-padding">
            <ion-grid>
              <ion-row class="ion-no-padding selecteds">
                <ion-fab-button *ngFor="let val of item.value" size="small">
                  {{ val }}
                </ion-fab-button>
              </ion-row>

              <ion-toolbar class="toolbar">
                <ion-img slot="start" class="ion-margin-top small" [src]="logoChispazo"></ion-img>

                <ion-buttons slot="end">
                  <ion-button (click)="changeSelected(i)" [color]="selected[i] ? 'success' : 'light'">
                    <ion-icon slot="icon-only" [name]="selected[i] ? 'checkmark-circle-outline' : 'ellipse-outline'">
                    </ion-icon>
                  </ion-button>

                  <ion-button (click)="deleteValue(i)" color="danger">
                    <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                  </ion-button>
                </ion-buttons>
              </ion-toolbar>
            </ion-grid>
          </ion-card-content>
        </ion-card>
      </ion-col>

      <ion-col *ngFor="let item of trisTickets; let i = index" size="12">
        <ion-card class="ion-no-margin tris">
          <ion-card-content class="ion-no-padding">
            <ion-grid>
              <ion-row class="ion-no-padding selecteds">
                <ion-fab-button *ngFor="let val of item.value" size="small">
                  {{ val >= 0 ? val : '' }}
                </ion-fab-button>
              </ion-row>

              <ion-toolbar class="toolbar">
                <ion-img slot="start" class="ion-margin-top small" [src]="logoTris"></ion-img>

                <ion-buttons slot="end">
                  <ion-button (click)="changeSelected(i)" [color]="selected[i] ? 'success' : 'light'">
                    <ion-icon
                      slot="icon-only"
                      [name]="selected[i] ? 'checkmark-circle-outline' : 'ellipse-outline'"
                    ></ion-icon>
                  </ion-button>

                  <!-- <ion-button *ngIf="option === 'automatic'" (click)="reload(i)" color="secondary">
                    <ion-icon slot="icon-only" name="refresh"></ion-icon>
                  </ion-button>

                  <ion-button *ngIf="option !== 'coperacha'" (click)="goTo()" color="secondary">
                    <ion-icon slot="icon-only" name="create-outline"></ion-icon>
                  </ion-button> -->

                  <ion-button (click)="deleteValue(i)" color="danger">
                    <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                  </ion-button>
                </ion-buttons>
              </ion-toolbar>
            </ion-grid>
          </ion-card-content>
        </ion-card>
      </ion-col>

      <ion-col *ngFor="let item of ganaGatoTickets; let i = index" size="12">
        <ion-card class="ion-no-margin gana-gato">
          <ion-card-content class="ion-no-padding">
            <ion-grid>
              <ion-row class="ion-no-padding selecteds">
                <ion-fab-button *ngFor="let val of item.value" size="small">
                  {{ val }}
                </ion-fab-button>
              </ion-row>

              <ion-toolbar class="toolbar">
                <ion-img slot="start" class="ion-margin-top small" [src]="logoGanaGato"></ion-img>

                <ion-buttons slot="end">
                  <ion-button (click)="changeSelected(i)" [color]="selected[i] ? 'success' : 'light'">
                    <ion-icon
                      slot="icon-only"
                      [name]="selected[i] ? 'checkmark-circle-outline' : 'ellipse-outline'"
                    ></ion-icon>
                  </ion-button>

                  <!-- <ion-button *ngIf="option === 'automatic'" (click)="reload(i)" color="secondary">
                    <ion-icon slot="icon-only" name="refresh"></ion-icon>
                  </ion-button>

                  <ion-button *ngIf="option !== 'coperacha'" (click)="goTo()" color="secondary">
                    <ion-icon slot="icon-only" name="create-outline"></ion-icon>
                  </ion-button> -->

                  <ion-button (click)="deleteValue(i)" color="danger">
                    <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                  </ion-button>
                </ion-buttons>
              </ion-toolbar>
            </ion-grid>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
